import React, { createContext, useContext, useState, ReactNode } from 'react';
import { AllDrinks } from '../types/DrinkTypes';

interface DrinkCustomizationState {
    drinks: AllDrinks;
    setDrinks: (drinks: AllDrinks) => void;
    isLoading: boolean;
    setIsLoading: (loading: boolean) => void;
}

const initialState: DrinkCustomizationState = {
    drinks: {
        drinks: [],
        water_supply: {
            id: 0,
            fountain_machine: 0,
            delivered_quantity: 0,
            solenoid_valve_activation_max_duration_ms: 0,
            dispense_tolerance: "0.0",
            relay_number_still: 0,
            relay_number_sparkling: 0,
            flow_meter_k_factor: 0,
            flow_meter_sleep_time: 0,
            flow_meter_gpio_pin: 0
        },
        fountain_machine: null
    },
    setDrinks: () => { },
    isLoading: true,
    setIsLoading: () => { },
};

const DrinkCustomizationContext = createContext<DrinkCustomizationState>(initialState);

export const DrinkCustomizationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [drinks, setDrinks] = useState<AllDrinks>(initialState.drinks);

    return (
        <DrinkCustomizationContext.Provider
            value={{
                drinks, setDrinks, isLoading, setIsLoading
            }}
        >
            {children}
        </DrinkCustomizationContext.Provider>
    );
};

export const useDrinkCustomization = () => useContext(DrinkCustomizationContext);
